export enum GlobalAccountType {
    EMPLOYEE = "EMPLOYEE",
    ADVISOR = "ADVISOR",
    CUSTOMER = "CUSTOMER",
    UNKNOWN = "UNKNOWN"
}
